/**
 * Deterministic 32-bit PRNG (mulberry32) for arcade simulations.
 *
 * The server picks the seed with its CSPRNG; this generator only has to be
 * reproducible, so the client and the server's replay produce identical
 * games from the same seed. Integer operations only: no floats, no Math.random.
 */
export class ArcadeRng {
  private state: number;

  constructor(seed: number) {
    this.state = seed >>> 0;
  }

  /** Next unsigned 32-bit value. */
  next(): number {
    this.state = (this.state + 0x6d2b79f5) | 0;
    let t = this.state;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return (t ^ (t >>> 14)) >>> 0;
  }

  /** Integer in [min, max). */
  int(min: number, max: number): number {
    if (max <= min) return min;
    return min + (this.next() % (max - min));
  }

  /** Snapshot for state copies. */
  get raw(): number {
    return this.state;
  }
}
